// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HomeFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HomeFilledIcon" ref={forwardedRef} {...props}>
      <path d="m9.89 2.763 8.26 6.017-1.178 1.617L15.5 9.325v6.815A.86.86 0 0 1 14.64 17H4.86A.86.86 0 0 1 4 16.14V9.51l-1.222.886-1.175-1.618zm1.358 9.028h-3v3.918H8.25V17h3v-1.5h-.002z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const HomeFilledIcon = /* @__PURE__ */ Object.assign(
  HomeFilledIconComponent,
  { displayName: 'HomeFilledIcon' },
);
